import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "saat" }
const _hoisted_2 = { class: "layout-wrapper layout-content-navbar" }
const _hoisted_3 = { class: "layout-container" }
const _hoisted_4 = { class: "layout-page" }
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "layout-overlay layout-menu-toggle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "drag-target" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Sidebar),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Navbar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_view)
            ])
          ])
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ])
  ]))
}